exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ConsultantDashboard-headingWithActions {\n  display: flex;\n  align-items: center; }\n  .ConsultantDashboard-headingWithActions-heading {\n    flex-grow: 1; }\n", ""]);

// exports
